<template>
  <div class="col-xxl-12 mb-5" v-if="isShowHoodiePageBoolean">
    <div class="card my-5">
      <div class="card-body border-0 pt-5">
        <div class="container">

          <!-- Available Count -->
          <div class="border border-gray-300 border-dashed rounded min-w-100px py-3 px-4 me-6 mb-5">
            <div class="d-flex align-items-center">
              <span class="svg-icon svg-icon-3 svg-icon-danger me-2"></span>
              <div class="fs-2 fw-bolder">
                {{ unclaimed_hoodie_jacket }}
              </div>
            </div>
            <div class="fw-bold fs-6 text-gray-400">&nbsp;&nbsp;Available Hoodie Jackets</div>
          </div>

          <!-- Hoodie Images -->
          <h2 class="card-label fw-bolder fs-3 mb-3">Choose Your Hoodie</h2>
          <div class="hoodie-grid">
            <div
              v-for="(hoodie, index) in hoodies"
              :key="index"
              class="hoodie-card"
              :class="{ selected: selectedHoodie === index }"
              @click="selectHoodie(index)"
            >
              <img :src="hoodie.url" class="hoodie-img" />
              <p class="hoodie-label">{{ hoodie.label }}</p>
            </div>
          </div>

          <!-- Quantity per Size -->
          <div class="section">
            <h2 class="card-label fw-bolder fs-3 mb-3">Enter Quantity Per Size</h2>
            <div class="grid grid-cols-2 gap-3" style="max-width: 400px;">
              <div
                v-for="(size, index) in sizes"
                :key="index"
                class="d-flex align-items-center mb-2"
              >
                <label :for="'size-' + size" style="width: 80px; font-weight: bold;">{{ size }}:</label>
                <input
                  type="text"
                  :id="'size-' + size"
                  v-model="quantitiesBySize[size]"
                  @input="filterSizeInput(size)"
                  @blur="removeLeadingZerosFromSize(size)"
                  class="form-control quantity-input"
                  style="width: 80px;"
                />
              </div>
            </div>
          </div>

          <!-- Branch Selection -->
          <div class="section">
            <h2 class="card-label fw-bolder fs-3 mb-3">Select Pick-up Branch</h2>
            <select v-model="selectedBranch" class="size-dropdown" @change="updateSelectedBranchText($event)">
              <option value="" disabled selected>Select a branch</option>
              <template v-for="(branch, index) in branches" :key="index">
                <option :value="branch.branch_code" v-if="branch.branch_code !== '0067' && branch.branch_code !== '0070'">
                  {{ branch.description }}
                </option>
              </template>
            </select>
          </div>

          <!-- Order Summary -->
          <div class="summary mb-4">
            <h3 class="summary-title">Summary</h3>
            <p><strong>Hoodie:</strong> {{ selectedHoodie !== -1 ? hoodies[selectedHoodie].label : 'Please select your hoodie' }}</p>
            <p><strong>Size and Quantity:</strong></p>
            <ul style="margin-left: 1rem;">
              <li v-for="(qty, size) in quantitiesBySize" :key="size" v-show="totalQty > 0">
                {{ size }} – {{ qty }} pc(s)
              </li>
              <li v-if="totalQty === 0">None selected</li>
            </ul>
            <p><strong>Total:</strong> {{ totalQty }} pc(s)</p>
            <p><strong>Pick-up:</strong> {{ selectedBranchText || 'Please select a branch' }}</p>
          </div>

          <!-- Confirmation -->
          <div class="section confirmation mb-4">
            <label>
              <input type="checkbox" v-model="confirmed" />
              I confirm the details above are correct.
            </label>
          </div>
          <div class="section mb-4" v-if="confirmed">
            <button type="button" class="btn btn-primary" :disabled="isLoading" @click="submitHoodieDetails">
              Submit
            </button>
          </div>

        </div>
      </div>
    </div>


    <div class="card">
      <div class="card-body py-3">
        <h3 class="card-title align-items-start flex-column my-5">
          <span class="card-label fw-bolder fs-3 ">History</span>
        </h3>
        <!-- <p class=" my-5"> Note: Orders will be available in approximately <font color="red">thirty (30) days</font> for Metro Manila. Additional <font color="red">seven (7) days</font> for orders outside Metro Manila. 
          <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Claim code will be available once the order is ready for pick-up at the selected branch.</p>
         -->

        <!-- Desktop Table View -->
        <div v-if="isMobile == false">
            <div class="table-responsive">
              <table class="table align-middle gs-0 gy-4">
                <thead>
                  <tr class="fw-bolder text-muted bg-light">
                    <th class="ps-4 min-w-100px rounded-start">Order #</th>
                    <!-- <th class="min-w-100px">Usid</th> -->
                    <th class="min-w-100px">Details</th>
                    <th class="min-w-200px">Branch</th>
                    <th class="min-w-200px">Order Date</th>
                    <th class="min-w-150px">Claim Code</th>
                    <th class="min-w-150px rounded-end">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in list" :key="item.recid">
                    <tr>
                      <td class="ps-4">{{ item.recid }}</td>
                      <!-- <td>{{ item.usid }}</td> -->
                      <td>{{ item.hoodie_qty }} pc(s). of {{ item.hoodie_design }} 
                        
                        
                        <button
                          type="button"
                          class="btn btn-sm btn-primary px-2 py-2"
                          data-bs-toggle="modal"
                          :data-bs-target="`#kt_modal_hoodie_items`"
                          v-on:click="getHoodieOrderDetails(item.recid, item.hoodie_qty, item.hoodie_design);"
                        >
                        View Items
                        </button>
                        <HoodieOrderDetails widget-classes="card-xxl-stretch mb-5 mb-xxl-8" :totalQty="overall_total_qty" :dzyn="dzyn" :ordernum="ordernum" :list="order_details_list"></HoodieOrderDetails>
                        
                      
                      </td>
                      <td>{{ item.branch }}</td>
                      <td>{{ formatDate(item.date_inserted) }}</td>
                      <td>{{ item.claim_code == '' ? '-----' : item.claim_code}}</td>
                      <td>
                        {{
                          item.sts == 0
                            ? 'Pending'
                            : item.sts == 1
                            ? 'Ready for Pick-up'
                            : item.sts == 2
                            ? 'Claimed'
                            : ''
                        }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
        </div>
        

        <!-- Mobile Card View -->
        <div class="grid gap-4" v-if="isMobile">
          <template v-for="(item, index) in list" :key="index">
            <div class="border rounded-lg p-4 shadow-sm bg-white py-5 my-5">
              <p><strong>Order #:</strong> {{ index + 1 }}</p>
              <p><strong>Status:</strong>
                {{
                  item.sts == 0
                    ? 'Pending'
                    : item.sts == 1
                    ? 'Ready for Pick-up'
                    : item.sts == 2
                    ? 'Claimed'
                    : ''
                }}
              </p>
              <p>{{ item.hoodie_qty }} pc(s). of {{ item.hoodie_design }} <button
                          type="button"
                          class="btn btn-sm btn-primary px-2 py-2"
                          data-bs-toggle="modal"
                          :data-bs-target="`#kt_modal_hoodie_items`"
                          v-on:click="getHoodieOrderDetails(item.recid, item.hoodie_qty, item.hoodie_design);"
                        >
                        View Items
                        </button>
                      <HoodieOrderDetails widget-classes="card-xxl-stretch mb-5 mb-xxl-8" :totalQty="overall_total_qty" :dzyn="dzyn" :ordernum="ordernum" :list="order_details_list"></HoodieOrderDetails>
              </p>
              <p><strong>Branch: </strong>{{ item.branch }}</p>
              <p><strong>Order Date: </strong> {{ formatDate(item.date_inserted) }}</p>
              <p><strong>Your claim code is: </strong> </p>
              <p align="center"><strong><font style="Times New Roman" size="5">{{ item.claim_code == '' ? '-----' : item.claim_code}}</font></strong> </p>
              
            </div>
          </template>
        </div>

        

      </div>
    <!--begin::Body-->
    </div>


  </div>
</template>

<script >
import {getHoodieJacketModelData, submitHoodieDetailsApi, getHoodieJacketOrderListApi, isShowHoodiePageApi, getHoodieOrderDetailsApi}  from "@/api/hoodiejacket";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import HoodieOrderDetails from "@/components/hoodiejacket/HoodieOrderDetails.vue";


export default {
  components: {
    HoodieOrderDetails
  },
  data() {
    return {
      sizes: ['Small', 'Medium', 'Large', 'XL', 'XXL'],
      quantitiesBySize: {
        Small: 0,
        Medium: 0,
        Large: 0,
        XL: 0,
        XXL: 0,
      },
      selectedHoodie: -1,
      hoodies: [
        { url: 'https://images.empoweredconsumerism-static-files.com/ovi/hoodies/BLACK_EMPOWER.jpg', label: 'Black Empower' },
        { url: 'https://images.empoweredconsumerism-static-files.com/ovi/hoodies/WHITE_EMPOWER.jpg', label: 'White Empower' },
        { url: 'https://images.empoweredconsumerism-static-files.com/ovi/hoodies/BLACK_OOTD_MNL.jpg', label: 'Black OOTD MNL' },
        { url: 'https://images.empoweredconsumerism-static-files.com/ovi/hoodies/LBLUE_DREAMER.jpg', label: 'Light Blue Dreamer' },
        { url: 'https://images.empoweredconsumerism-static-files.com/ovi/hoodies/RED_DRIVEN.jpg', label: 'Red Driven' }
      ],
      selectedBranch: '',
      selectedBranchText: '',
      confirmed: false,
      isLoading: false,
      branches: [],
      unclaimed_hoodie_jacket: 0,
      list : [],
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      isMobile : false,
      isShowHoodiePageBoolean : false,
      totalQty : 0,
      order_details_list : [],
      overall_total_qty : 0,
      dzyn : '', 
      ordernum : -1,
      hoodie_key : 0,
    };
  },
  methods: {
    selectHoodie(index) {
      this.selectedHoodie = index;
      this.resetConfirmation();
    },
    resetConfirmation() {
      this.confirmed = false;
    },
    filterSizeInput(size) {
      const raw = String(this.quantitiesBySize[size]).replace(/[^0-9]/g, '');
      this.quantitiesBySize[size] = raw === '' ? 0 : parseInt(raw);
      this.getTotalQuantity();
      this.resetConfirmation();
    },
    removeLeadingZerosFromSize(size) {
      let val = String(this.quantitiesBySize[size]).replace(/^0+/, '');
      this.quantitiesBySize[size] = val === '' ? 0 : parseInt(val);
      this.getTotalQuantity();
    },
    getTotalQuantity() {
      this.totalQty = Object.values(this.quantitiesBySize).reduce((sum, qty) => sum + Number(qty), 0);
    },
    updateSelectedBranchText(event) {
      const selectedOption = event.target.options[event.target.selectedIndex];
      this.selectedBranchText = selectedOption.text;
      this.resetConfirmation();
    },
    async submitHoodieDetails(){
      
      if(this.selectedHoodie == -1){
        Swal.fire({
          title: "",
          text: "Please select your hoodie first.",
          icon: "error",
          confirmButtonClass: "btn btn-secondary"
        }); 
        return; 
      } else if(this.totalQty <= 0){
        Swal.fire({
          title: "",
          text: "Please enter quantity.",
          icon: "error",
          confirmButtonClass: "btn btn-secondary"
        }); 
        return;
      } else if(this.selectedBranch == ""){
        Swal.fire({
          title: "",
          text: "Please select a pick-up branch.",
          icon: "error",
          confirmButtonClass: "btn btn-secondary"
        }); 
        return;
      } else {
        let param = {
          "dzyn" : this.hoodies[this.selectedHoodie].label,
          "syz" : this.quantitiesBySize,
          "branch" : this.selectedBranch,
          "total_qty" : this.totalQty
        }

        
        const response = await submitHoodieDetailsApi(param);
        if(response != null){  
          // TO DO: unblockUI();
          if (response.data.result == "SUCCESS") {
            
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "success",
              confirmButtonClass: "btn btn-secondary",
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            }); 
            
          } else if(response.data.result == "FAILED"){
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "error",
              confirmButtonClass: "btn btn-secondary"
            }); 
            return; 
          }
        }
        
      }
    },
    async getHoodieJacketModelDataMethod(){
      const response = await getHoodieJacketModelData();
      this.unclaimed_hoodie_jacket = response.data.unclaimed_hoodies;
      this.branches = response.data.branches;
    },
    async getHoodieJacketOrderList(){
      const response = await getHoodieJacketOrderListApi();
      this.list = response.data.pageList;
    },
    async isShowHoodiePage(){
      const response = await isShowHoodiePageApi();
      this.isShowHoodiePageBoolean = response.data.isShowHoodiePage;
      if(this.isShowHoodiePageBoolean == false){
        this.$router.push('/estore') ;
      }
    },
    onResize() {
      //this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
      if(this.windowWidth <= 450){
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    async getHoodieOrderDetails(recid, qty, dezyn){

      this.overall_total_qty = qty;
      this.dzyn = dezyn; 
      this.ordernum = recid;

      let param = {
        "orderid" : recid
      }
      const response = await getHoodieOrderDetailsApi(param)
      this.order_details_list = response.data.detailsList;
    },
  },
  
  mounted(){
      this.getHoodieJacketModelDataMethod();
      this.getHoodieJacketOrderList();
      this.onResize();
      this.isShowHoodiePage();
      
  },
  setup() {
    const tabIndex = ref(0);

    onMounted(() => {
      // set the tab from previous
      tabIndex.value = parseInt(localStorage.getItem("encashmentTab") || "0");

      setCurrentPageTitle("Hoodies!");
    });

    
  }
};
</script>

<style scoped>
.hoodie-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
  justify-items: center;
}

.hoodie-card {
  border: 2px solid #ccc;
  border-radius: 8px;
  padding: 0.5rem;
  text-align: center;
  cursor: pointer;
  transition: 0.2s;
}

.hoodie-card:hover {
  transform: scale(1.03);
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
}

.hoodie-card.selected {
  border-color: #007bff;
  box-shadow: 0 0 0 2px #007bff66;
  background-color: #e6f2ff;
}

.hoodie-img {
  width: 100%;
  object-fit: cover;
  border-radius: 4px;
  max-width: 200px;
}

.hoodie-label {
  margin-top: 0.5rem;
  font-weight: 500;
}

.section {
  margin-bottom: 1.5rem;
}

.quantity-input {
  padding: 0.5rem;
  font-size: 1rem;
  width: 80px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.summary {
  background: #f1f1f1;
  padding: 1rem;
  border-radius: 6px;
  font-size: medium;
}

.summary-title {
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.size-dropdown {
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  min-width: 160px;
}
</style>
